if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      const variantId = formData.get('id');
      const quantity  = parseInt(formData.get('quantity') || 1);

      // 先清空购物车，再以页面选择数量重新添加，防止数量叠加
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(() => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
        });
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          // 出错（如缺货）：显示错误信息，恢复按钮状态
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: response.description,
            message: response.message
          });
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          return;
        }

        // ✅ 触发 Meta Pixel InitiateCheckout 事件
        // 价格来源：ShopifyAnalytics.meta.product.variants（单位：分）
        if (typeof fbq === 'function') {
          try {
            let price = 0;
            const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

            // 从 ShopifyAnalytics.meta 读取当前 variant 价格（最准确）
            const saVariants = window.ShopifyAnalytics &&
                               window.ShopifyAnalytics.meta &&
                               window.ShopifyAnalytics.meta.product &&
                               window.ShopifyAnalytics.meta.product.variants;

            if (saVariants && saVariants.length > 0) {
              const currentVariant = saVariants.find(v => String(v.id) === String(variantId));
              const targetVariant  = currentVariant || saVariants[0];
              // Shopify 价格单位是"分"，除以 100 得到实际金额
              price = (targetVariant.price / 100).toFixed(2);
            } else {
              // 备用：从 DOM 读取 sale price 文字
              const priceEl = document.querySelector('.price-item--sale') ||
                              document.querySelector('.price-item--regular') ||
                              document.querySelector('[data-product-price]');
              if (priceEl) {
                price = parseFloat(priceEl.innerText.replace(/[^0-9.]/g, '')) || 0;
              }
            }

            fbq('track', 'InitiateCheckout', {
              value: parseFloat(price),
              currency: currency,
              num_items: quantity,
              content_ids: [String(variantId)],
              content_type: 'product'
            });
          } catch(e) {
            console.warn('Meta Pixel InitiateCheckout error:', e);
          }
        }

        // ✅ 直接跳转结账（fbq 内部用 sendBeacon 保证事件不丢失）
        window.location.href = '/cart';
      })
      .catch((e) => {
        console.error(e);
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
